import { useEffect } from "react";
import { useAuth } from "react-oidc-context";


export default function LoginRedirection() {

    const auth = useAuth();
    useEffect(() => {
        auth.signinRedirect();
        }, [auth]);
}
